import { create_mock_plan as create_gql_mock_plan } from "@/gql/lib";
import { create_mock_plan as create_rest_api_mock_plan } from "@/common/api/ApiResult.model";
import { Env } from "@/common/models";

import { executives } from "./executives.mock";
import { compliance } from "./compliance.mock";
import { manage_exposure } from "./manage-exposure.mock";
import { risky_users, risky_users_gql } from "./risky-users.mock";
import { recommendations } from "./recommendations.mock";
import { unprotected_mfa_accounts } from "./unprotected-mfs-accounts";
import { info_motion } from "./info-motion";
import { where_departments } from "./where-departments.mock";
import { mass_download } from "./mass-download.mock";
import { folders_context_labels } from "./folders-context.mock";
import { motion_connectors } from "./info-in-motion-connectors.mock";
import { gen_ai_gql } from "./gen-ai.mock";
// @ts-ignore
window.toggle_mock = (is_active: boolean) => {
  // @ts-ignore
  window._gql_mock_plan.activate = is_active;
  // @ts-ignore
  window._rest_mock_plan.active = is_active;
};

export const init_mocking = (env: Env, is_preview: boolean) => {
  if (["debug", "local", "qa", "uat", "preview"].includes(env.env)) {
    create_gql_mock_plan({
      activate: is_preview,
      delay: 1000,
      // @ts-ignore
      calls: {
        ...compliance,
        ...executives,
        ...where_departments,
        ...risky_users_gql,
        ...gen_ai_gql,
      },
    });

    create_rest_api_mock_plan({
      active: is_preview,
      delay: 1000,
      // @ts-ignore
      calls: {
        ...motion_connectors,
        ...recommendations,
        ...manage_exposure,
        ...risky_users,
        ...mass_download,
        ...unprotected_mfa_accounts,
        ...info_motion,
        ...folders_context_labels,
      },
    });
  }
};
